/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-bluetooth-off': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.5 16.619L3.381 2.5l-.881.881L9.119 10l-4.744 4.744.881.881 4.119-4.119v6.619a.625.625 0 001.031.475l3.938-3.375 2.275 2.275.881-.881zm-6.875.15v-5.263l2.831 2.832-2.831 2.43zm0-8.8V3.23l2.831 2.431-2.569 2.57.882.88 3.05-3.043A.625.625 0 0015 5.625a.625.625 0 00-.219-.45l-4.375-3.75a.625.625 0 00-1.031.45v4.844l1.25 1.25z"/>'
  }
})
